import React from 'react';
import { Card, Tag, Typography, Space } from 'antd';
import Link from 'next/link';
import {
  ClockCircleOutlined,
  EyeOutlined,
  BookOutlined,
  FileTextOutlined,
  QuestionCircleOutlined,
  BulbOutlined,
  GlobalOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const typeToUrlMap = {
  caseStudies: 'case-studies',
  industryNews: 'industry-news',
  articles: 'articles',
  faq: 'faq',
  guides: 'guides',
};

const getTypeIcon = (type) => {
  switch (type) {
    case 'articles':
      return <FileTextOutlined />;
    case 'faq':
      return <QuestionCircleOutlined />;
    case 'caseStudies':
      return <BookOutlined />;
    case 'guides':
      return <BulbOutlined />;
    case 'industryNews':
      return <GlobalOutlined />;
    default:
      return <FileTextOutlined />;
  }
};

const getTypeColor = (type) => {
  switch (type) {
    case 'articles':
      return '#05c168';
    case 'faq':
      return '#1890ff';
    case 'caseStudies':
      return '#f50';
    case 'guides':
      return '#722ed1';
    case 'industryNews':
      return '#eb2f96';
    default:
      return '#108ee9';
  }
};

const HelpCenterCard = ({ item, type }) => {
  const readingTime = Math.ceil(item.estimatedReadTime || 1);

  const getTitle = () => {
    if (type === 'faq') {
      return item.question || item.title;
    }
    return item.title || item.name;
  };

  const getPreview = () => {
    if (type === 'faq' && item.answer) {
      const text = item.answer.replace(/(<([^>]+)>)/gi, ''); // Remove any HTML tags
      return text.length > 150 ? `${text.substring(0, 150)}...` : text;
    }
    if (item.preview) {
      const text = item.preview.replace(/(<([^>]+)>)/gi, ''); // Remove any HTML tags
      return text.length > 150 ? `${text.substring(0, 150)}...` : text;
    }
    return '';
  };

  const getUrlPath = () => {
    return typeToUrlMap[type] || type;
  };

  return (
    <Link href={`/${getUrlPath()}/${item.slug?.current || item.slug || ''}`}>
      <Card hoverable className="help-center-card" style={{ height: '100%' }}>
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Tag color={getTypeColor(type)} icon={getTypeIcon(type)}>
            {type === 'faq'
              ? 'FAQ'
              : type.charAt(0).toUpperCase() + type.slice(1).replace(/([A-Z])/g, ' $1')}
          </Tag>

          <Title level={4} style={{ marginTop: 8, marginBottom: 8 }}>
            {getTitle()}
          </Title>

          {getPreview() && (
            <Text type="secondary" style={{ display: 'block' }}>
              {getPreview()}
            </Text>
          )}

          <Space size="large" style={{ marginTop: 'auto', color: '#8c8c8c' }}>
            {readingTime > 0 && type !== 'faq' && (
              <Text type="secondary">
                <ClockCircleOutlined /> {readingTime} min read
              </Text>
            )}
            {item.views && (
              <Text type="secondary">
                <EyeOutlined /> {item.views} views
              </Text>
            )}
          </Space>
        </Space>
      </Card>
    </Link>
  );
};

export default HelpCenterCard;
